import { isExplicitE2ETestMode } from "../utils/e2eMode";
import { isLocalIdentityMode } from "../utils/localIdentityMode";
import { hasAdapterSessionEnded } from "./authSession";

type BrowserAuthTokenProvider = () => Promise<string | null>;

let registration: { provider: BrowserAuthTokenProvider } | null = null;

export function registerBrowserAuthTokenProvider(
  provider: BrowserAuthTokenProvider,
): () => void {
  const entry = { provider };
  registration = entry;
  return () => {
    if (registration === entry) {
      registration = null;
    }
  };
}

export async function getBrowserAuthToken(): Promise<string | null> {
  if (registration) {
    const captured = registration;
    const value = await captured.provider();
    if (registration !== captured)
      throw new DOMException("Authentication context changed", "AbortError");
    return value;
  }
  if (isLocalIdentityMode()) {
    return hasAdapterSessionEnded()
      ? null
      : import.meta.env.VITE_LOCAL_IDENTITY_TOKEN;
  }
  if (isExplicitE2ETestMode()) {
    return hasAdapterSessionEnded() ? null : "mock-e2e-token";
  }
  return null;
}
